import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";
import WelcomePage from "../WelcomePage";

const AgendamentoUsina = lazy(() => import("./AgendamentoUsinaPage"));

export default function UsinaRoutes() {
  return (
    <Switch>
      <Route exact path="/" component={WelcomePage} />

      <Route path="/transportador/usina" component={AgendamentoUsina} />
    </Switch>
  );
}
